const IconTab1 = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.85 11.75V10.25H14.275C14.2 9.8 13.975 9.35 13.75 8.9L14.875 7.775L13.825 6.725L12.7 7.85C12.325 7.625 11.875 7.4 11.35 7.325V5.75H9.85V7.325C9.4 7.4 8.95 7.625 8.5 7.85L7.375 6.725L6.325 7.775L7.45 8.9C7.225 9.275 7 9.725 6.925 10.25H5.35V11.75H6.925C7 12.2 7.225 12.65 7.45 13.1L6.325 14.225L7.375 15.275L8.5 14.15C8.875 14.375 9.325 14.6 9.85 14.675V16.25H11.35V14.675C11.8 14.6 12.25 14.375 12.7 14.15L13.825 15.275L14.875 14.225L13.75 13.1C13.975 12.725 14.2 12.275 14.275 11.75H15.85ZM10.6 13.25C9.325 13.25 8.35 12.275 8.35 11C8.35 9.725 9.325 8.75 10.6 8.75C11.875 8.75 12.85 9.725 12.85 11C12.85 12.275 11.875 13.25 10.6 13.25Z"
      fill="currentColor"
    />
    <path
      d="M10.6 0.5V2C15.55 2 19.6 6.05 19.6 11C19.6 15.95 15.55 20 10.6 20V21.5C16.375 21.5 21.1 16.775 21.1 11C21.1 5.225 16.375 0.5 10.6 0.5Z"
      fill="currentColor"
    />
    <path
      d="M4.75 17.825L3.85 19.025C4.75 19.775 5.8 20.45 7 20.825L7.525 19.4C6.475 19.025 5.575 18.5 4.75 17.825Z"
      fill="currentColor"
    />
    <path
      d="M1.75 12.5L0.25 12.8C0.475 14 0.925 15.2 1.525 16.25L2.8 15.5C2.275 14.6 1.9 13.55 1.75 12.5Z"
      fill="currentColor"
    />
    <path
      d="M2.8 6.5L1.525 5.75C0.925 6.8 0.475 8 0.325 9.2L1.825 9.425C1.9 8.375 2.275 7.4 2.8 6.5Z"
      fill="currentColor"
    />
    <path
      d="M7.45 2.6L6.925 1.175C5.8 1.625 4.75 2.225 3.85 2.975L4.825 4.1C5.575 3.5 6.475 2.975 7.45 2.6Z"
      fill="currentColor"
    />
  </svg>
);

export default IconTab1;
